import {
    SET_AUTH,
    SET_SERVICE,
    SET_LOADING_INFO,
    SET_USER_LOGIN_INFO,
    SET_MAINTENANCE_MODE,
    SET_ACCOUNT_DIALER_INFO,
    APP_TYPE_DEFAULT,
    SET_USER_LOCALIZATION,
    APP_TYPE_ADMIN
} from "const";
import {
    NEED_SECOND_AUTH,
    SET_PERMISSION,
    SET_PERMISSION_ADD
} from "actions/actionTypes";
import { SET_INFO_ACCOUNT, SET_CAPTCHA_NEEDED, transformed_service_data } from "const";
import { SET_RULES_ACCEPT, SET_PRIVACY_ACCEPT } from "const/apiMethods";
import { getManagedServices } from "utils";
import { getSpecificValueFromSearch } from "utils/pathHelpers";
import history from "config/history";


const savedAuthInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;

const isAuth = !!localStorage.getItem("api_key") && !!savedAuthInfo?.session?.session_key;
const appTypeSaved = savedAuthInfo?.session?.site || APP_TYPE_DEFAULT;
const rulesNotAcceptedStored = savedAuthInfo?.rules_not_accepted || false;
const privacyNotAcceptedStored = savedAuthInfo?.privacy_not_accepted || false;
const role = savedAuthInfo?.session?.account_user?.role_list?.[0] || null;

const managedServiceList = getManagedServices(savedAuthInfo);
let managedService;

if (managedServiceList.length === 1) {
    managedService = transformed_service_data[managedServiceList[0]];
}

const savedLang = localStorage.getItem("lang");
const savedRtl = localStorage.getItem("rtl") && JSON.parse(localStorage.getItem("rtl"));

// ATX-2922
// try to return to get service from location method and find out why interface know about current service when location doesn"t

const serviceNameFromLocation = getSpecificValueFromSearch(history.location, "service");
const serviceFromLocation = transformed_service_data[serviceNameFromLocation];

const serviceSaved = appTypeSaved === APP_TYPE_ADMIN && !serviceFromLocation && localStorage.getItem("service") ? JSON.parse(localStorage.getItem("service")) : null;

const lastServiceBeforeSessionExpired = localStorage.getItem("LAST_SERVICE_BEFORE_SESSION_EXPIRED");

const initialState = {
    authInfo: savedAuthInfo || {}, // completed info
    rulesNotAccepted: rulesNotAcceptedStored,
    privacyNotAccepted: privacyNotAcceptedStored,
    auth: isAuth, // bool
    service: (serviceFromLocation !== null && serviceFromLocation !== undefined)
        ? serviceFromLocation
        : lastServiceBeforeSessionExpired ? transformed_service_data[lastServiceBeforeSessionExpired]
            : serviceSaved !== null ? serviceSaved : managedServiceList.length === 1 ? managedService : true,
    loading: false,
    permissions: [],
    permissionLoaded: false,
    permissions_add: [],
    role: role,
    dialerInfo: null,

    secondAuthType: null,
    secondAuthLink: null,
    secondAuthEmail: null,

    maintenanceMode: false,
    appType: appTypeSaved,
    lang: savedLang || "en",
    rtl: savedRtl || false,
    readyForPayment: {},
    captchaNeeded: false
};

const handlers = {
    [SET_AUTH]: (state, { payload, appType, clearPermissions }) => {
        const nextState = {
            ...state,
            auth: payload,
            appType: appType || APP_TYPE_DEFAULT,
            loading: false,
            secondAuthType: null,
            secondAuthLink: null,
            secondAuthEmail: null,
            permissions: clearPermissions ? [] : state.permissions,
            permissionLoaded: clearPermissions ? false : state.permissionLoaded,
            permissions_add: [],
        };
        return nextState;
    },
    [SET_SERVICE]: (state, { payload }) => {
        return { ...state, service: payload }
    },
    [SET_RULES_ACCEPT]: (state, { payload }) => ({ ...state, rulesNotAccepted: payload }),
    [SET_PRIVACY_ACCEPT]: (state, { payload }) => ({ ...state, privacyNotAccepted: payload }),
    [SET_USER_LOGIN_INFO]: (state, { payload }) => ({
        ...state,
        authInfo: payload,
        rulesNotAccepted: payload.rules_not_accepted,
        privacyNotAccepted: payload.privacy_not_accepted,
        appType: payload.session.site
    }),
    [SET_USER_LOCALIZATION]: (state, { payload }) => ({ ...state, lang: payload.lang, rtl: payload.rtl }),
    [SET_INFO_ACCOUNT]: (state, { payload }) => ({ ...state, authInfo: payload, loading: false }),
    [SET_ACCOUNT_DIALER_INFO]: (state, { payload: {
        accountJoinList, readyForPayment, ...payload
    } }) => ({
        ...state,
        dialerInfo: payload,
        accountJoinList,
        readyForPayment
        // readyForPayment: payload.available_for_payment || 0
    }),
    [SET_LOADING_INFO]: (state, { payload }) => ({ ...state, loading: payload }),
    [NEED_SECOND_AUTH]: (state, { payload }) => ({ ...state, ...payload }),
    [SET_PERMISSION]: (state, { payload }) => {
        return { ...state, permissions: payload, permissionLoaded: true };
    },
    [SET_PERMISSION_ADD]: (state, { payload }) => {
        return { ...state, permissions_add: payload };
    },
    [SET_MAINTENANCE_MODE]: (state, { payload }) => ({ ...state, maintenanceMode: payload }),
    [SET_CAPTCHA_NEEDED]: (state, { payload }) => ({ ...state, captchaNeeded: payload }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action)
};


